import createReactComponent from '../createReactComponent';
export default createReactComponent('grid-goldenratio', 'IconGridGoldenratio', [
  ['path', { d: 'M3 10h18', key: 'svg-0' }],
  ['path', { d: 'M3 14h18', key: 'svg-1' }],
  ['path', { d: 'M10 3v18', key: 'svg-2' }],
  ['path', { d: 'M14 3v18', key: 'svg-3' }],
]);
